import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TextareaAutosizeDirective } from '../../directives/textarea-autosize/textarea-autosize.directive'
import { NewCustomFormControl } from '../../helpers/new-custom-nested-form'

@Component({
  selector: 'wm-front-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, TextareaAutosizeDirective],
})
export class TextareaComponent extends NewCustomFormControl {
  /** The input's label */
  @Input() public label?: string

  /** Draws the required mark after the label (PRENG-8287), instead of a star written in the label's translation */
  @Input() public requiredMark = false

  /** The input's placeholder */
  @Input() public placeholder = ''

  /** The state enabled or not of the input */
  @Input() public disabled?: boolean

  /** Enable the auto height of the component */
  @Input() public autoSize = true

  /** Maximum number of characters */
  @Input() public maxLength: number

  /** Handle touch behaviour */
  @Output() public touched: EventEmitter<null> = new EventEmitter()

  public override ngControl: NgControl

  constructor() {
    const ngControl = inject(NgControl, { optional: true, self: true })
    super(ngControl as NgControl)
    this.ngControl = ngControl as NgControl
  }

  /** Character count
   * @returns { number }
   */
  public get characterCount(): number {
    return this.value?.length || 0
  }

  /** Emit on focus */
  public onFocus(): void {
    this.touched.emit()
  }
}
